module.exports = __webpack_public_path__ + "img/镜子.ceefce75.png";